import { BaseModel } from "@blue-chip/core";

export default class Notification extends BaseModel {}
